import React from "react";

const Blogs = () => {
  return (
    <div className="font">
      <h2 className="text-center my-3">Coming Soon</h2>
    </div>
  );
};

export default Blogs;
